import IMG from "../../constants/image";
import React from "react";
import './style.css';
import ProductForm from "./ProductForm";
import {createProduct} from "../../network/api";
import {PATH} from "../../constants";
import {useNavigate} from "react-router-dom";
import popupStore from "../../store/popupStore";
import appStore from "../../store/appStore";

const CreateProduct = () => {
    const navigate = useNavigate();
    const {setPopup} = popupStore() || {};
    const {setLoading} = appStore() || {};

    const handleSubmitData = async (newFormData) => {
        const res = await createProduct(newFormData);
        setLoading(false)
        if (res?.success) {
            setPopup({
                isOpen: true,
                data: {
                    title: 'Bạn đã tạo sản phẩm thành công',
                    desc: 'Ban quản trị đang duyệt nội dung sản phẩm của bạn sẽ được đăng trong thời gian sớm nhất.',
                    image: IMG.createProductSuccess,
                    accept: {
                        label: 'Về trang quản lý sản phẩm',
                        action: () => {
                            setPopup({})
                            navigate(PATH.MANAGING_PRODUCT)
                        }
                    }
                }
            })
        }

        return res;
    }

    return (
        <div className=''>
            <div className='hidden md:flex justify-center items-center gap-[5px] mb-2.5'>
                <img className='' src={IMG.icon.boxBorderGreen} alt="boxBorderGreen"/>
                <p className='text-sm md:text-xl font-bold'>Tạo sản phẩm</p>
            </div>
            <div className='bg-white rounded-xl w-full'>
                <ProductForm
                    isAdding
                    actionSubmit={handleSubmitData}
                    buttonSubmit='Tạo sản phẩm'
                />
            </div>
        </div>
    )
};

export default CreateProduct;
